import { Component, OnInit, ViewChild } from '@angular/core';
import { ElectService } from '../service/elect.service';
import { Router, NavigationExtras } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import firebase from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
@Component({
  selector: 'app-voting',
  templateUrl: './voting.component.html',
  styleUrls: ['./voting.component.css']
})
export class VotingComponent implements OnInit {

	phoneNumber;
	uid;
	data: any;
	rdata;
	myvotes: any = [];
	ready: boolean = false;
	casted: boolean = false;
	voted: any;
  enableVote;

  constructor(private elsrv: ElectService,   
              public router: Router,
              private route: ActivatedRoute,
              private afa: AngularFireAuth
              ) { }

  ngOnInit(): void {

     this.afa.onAuthStateChanged(da => {
      if(da == null){
        console.log('No Active User')
        this.router.navigate(['/']); 
      }
    });
  	this.route.queryParams.subscribe(params => {
		let value_1 = params['key'];
		let value_2 = params['uid'];
	    this.phoneNumber = value_1;
	    this.uid = value_2;
	    this.elsrv.getActiveVoter(value_1).subscribe(data =>{
            if(data.length != 1){
              this.router.navigate(['unregvoter'], {queryParams : {stat:'noact'}});
            }else{
            	this.data = data;
            	this.elsrv.getNo().subscribe(rdata => {
			  		this.rdata = rdata;
			  	});
            }
	    });

	    this.elsrv.getMyVotes(value_2).subscribe(d => {
            if(d.length == 1){
            	this.casted = true;
            	this.elsrv.getMyVoteData(value_2).subscribe(vd=>{
            		this.voted = vd;
            	});
            }else{
            	this.casted = false;
            }
	    });
  	});
    this.checkTime();
  }
  addVote(s){
  	console.log(this.myvotes.length);
  	if(this.myvotes.length < 6){
	  	let data = this.myvotes.find(ob => ob.fullName === s.fullName);
		if(data == null){
	 		this.myvotes.push(s);
		}

  	}
  	else{
  		alert("YOU CAN VOTE 6 CANDIDATES ONLY!")
  	}

  	if(this.myvotes.length > 5){
		this.ready = true;
	}else{
		this.ready = false;
	}
  }
  delVote(x){
    const index: number = this.myvotes.indexOf(x);
    if (index !== -1) {
        this.myvotes.splice(index, 1);
    }

    if(this.myvotes.length > 5){
		this.ready = true;
	}else{
		this.ready = false;
	}
  }
  castVote(){
  	const createAt = firebase.firestore.FieldValue.serverTimestamp(); 
    const vot = {
      createAt: createAt,
      voterUid: this.uid
    }
    this.elsrv.addVotes(vot);
    const swe = this.myvotes;
    swe.forEach((doc)=>{
      const yuo = {
        voterUid: this.uid,
        vote: doc.fullName,
        castOn: createAt
      }
      firebase.firestore().collection('votedata').doc().set(yuo);
    });
    this.router.navigate(['/votesuccess'], { queryParams: { stat: 'vo' }, skipLocationChange: false });
  }
  goout(){
    this.afa.signOut();
    this.router.navigate(['/']);    
  }


   checkTime(){
    const sdate = new Date("2020/12/14 00:00:01").getTime();
    const edate = new Date("2020/12/16 11:59:59").getTime();
    const ndate = new Date().getTime();

    if(ndate > sdate && ndate < edate){
      this.enableVote = true;
    }else{
      this.enableVote = false;
    }
  }
}